import type { QuoteTrackingContext } from '../types';

export const getPageTypeFromPath = (pagePath: string) => {
    const segments = pagePath.split('/').filter(Boolean);
    const route = segments[1];
    const detailSegment = segments[2];

    if (!route) return 'home';
    if (route === 'services' || route === 'paslaugos') return detailSegment ? 'service_detail' : 'services';
    if (route === 'languages' || route === 'kalbos') return 'languages';
    if (route === 'about' || route === 'apie-mus') return 'about';
    if (route === 'news' || route === 'naujienos') return detailSegment ? 'news_article' : 'news';
    if (route === 'faq' || route === 'duk') return 'faq';
    if (route === 'contact' || route === 'kontaktai') return 'contact';
    if (route === 'careers' || route === 'karjera') return detailSegment ? 'careers_detail' : 'careers';
    return route;
};

const getCurrentLocale = () =>
    typeof window !== 'undefined' && window.location.pathname.startsWith('/lt') ? 'LT' : 'EN';

export const createQuoteTrackingContext = ({
    entrypoint,
    surface,
    quoteMode = 'standard',
    isCta = true,
    pagePath,
    pageType,
    locale,
}: {
    entrypoint: string;
    surface: string;
    quoteMode?: string;
    isCta?: boolean;
    pagePath?: string;
    pageType?: string;
    locale?: string;
}): QuoteTrackingContext => {
    const resolvedPagePath =
        pagePath ?? (typeof window !== 'undefined' ? window.location.pathname : '/');

    return {
        entrypoint,
        surface,
        pagePathAtClick: resolvedPagePath,
        pageTypeAtClick: pageType ?? getPageTypeFromPath(resolvedPagePath),
        localeAtClick: locale ?? getCurrentLocale(),
        quoteMode,
        isCta,
    };
};

export const getQuoteTrackingEventData = (tracking: QuoteTrackingContext | null | undefined) => {
    const resolved =
        tracking ??
        createQuoteTrackingContext({
            entrypoint: 'quote_modal',
            surface: 'quote_modal',
            isCta: false,
        });

    return {
        entrypoint: resolved.entrypoint,
        surface: resolved.surface,
        page_path_at_click: resolved.pagePathAtClick,
        page_type_at_click: resolved.pageTypeAtClick,
        locale_at_click: resolved.localeAtClick,
        quote_mode: resolved.quoteMode,
        is_cta: resolved.isCta,
    };
};
